import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	cta: {
		id: 'profile.form.update',
		defaultMessage: 'Update',
		description: 'An update button to change account details',
	},
});
